"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const styles_1 = __importDefault(require("./styles"));
const AccountMuteOverview = () => {
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                alignSelf: "center",
            }, title: "", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.rectangle }),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.title }, "\u30DF\u30E5\u30FC\u30C8\u6A5F\u80FD\u306B\u3064\u3044\u3066")),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description }, 'ミュート機能は、特定のユーザーの投稿や通知を自分のフィードから隠すために使用されます。この機能の影響は以下の通りです。\n\n投稿の非表示: ミュートしたユーザーの投稿やコメントは、あなたのフィードやタイムライン上に表示されなくなります。\n通知の非受信: ミュートしたユーザーからの通知が届かなくなります。これには、メンションやリプライなどが含まれます。\n相互作用の継続: ミュートしても、メッセージの送受信やユーザーのプロフィールの閲覧は可能です。'),
            react_1.default.createElement(components_1.BorderButton, { title: "\u30DF\u30E5\u30FC\u30C8\u4E00\u89A7\u306B\u623B\u308B", style: styles_1.default.backButton, textStyle: styles_1.default.backButtonLabel, onPress: rootNavigation_1.goBack }))));
};
exports.default = AccountMuteOverview;
